var map = {
	"./check": 396,
	"./check.svg": 396,
	"./en": 397,
	"./en.svg": 397,
	"./logo": 391,
	"./logo-all": 398,
	"./logo-all.svg": 398,
	"./logo-badge": 399,
	"./logo-badge.svg": 399,
	"./logo-full": 400,
	"./logo-full.svg": 400,
	"./logo-inline": 401,
	"./logo-inline.svg": 401,
	"./logo-new": 402,
	"./logo-new.svg": 402,
	"./logo.png": 391,
	"./logo.svg": 423,
	"./nb": 403,
	"./nb.svg": 403
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 422;